const STOCKHOLM_TIMEZONE = "Europe/Stockholm";

export function formatDateFull(date: string) {
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: STOCKHOLM_TIMEZONE,
  }).format(new Date(date));
}

export function formatDateMonthYear(date: string) {
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "long",
    timeZone: STOCKHOLM_TIMEZONE,
  }).format(new Date(date));
}

export function formatCurrentYear() {
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    timeZone: STOCKHOLM_TIMEZONE,
  }).format(new Date());
}
